import { render, staticRenderFns } from "./CargoAgGridColumnEditGroup2.vue?vue&type=template&id=52b0480c&"
import script from "./CargoAgGridColumnEditGroup2.vue?vue&type=script&lang=js&"
export * from "./CargoAgGridColumnEditGroup2.vue?vue&type=script&lang=js&"
import style0 from "./CargoAgGridColumnEditGroup2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52b0480c')) {
      api.createRecord('52b0480c', component.options)
    } else {
      api.reload('52b0480c', component.options)
    }
    module.hot.accept("./CargoAgGridColumnEditGroup2.vue?vue&type=template&id=52b0480c&", function () {
      api.rerender('52b0480c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/CargoAgGridColumnEditGroup2.vue"
export default component.exports